// extracted by mini-css-extract-plugin
module.exports = {"A_banner":"Banner_A_banner__kG_4B"};